import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallOutgoingIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CallOutgoing",
    children: /*#__PURE__*/_jsx("path", {
      d: "M23.536 17.813a1.15 1.15 0 0 0-1.58-.036l-.793.725a1.19 1.19 0 0 1-1.65-.038l-6.01-6.01a1.19 1.19 0 0 1-.003-1.688l.685-.683a1.14 1.14 0 0 0 .002-1.619L8.344 2.621a1.143 1.143 0 1 0-1.616 1.616l5.037 5.038c-.58.64-.9 1.462-.9 2.332 0 .93.362 1.806 1.021 2.462l6.011 6.011a3.47 3.47 0 0 0 4.795.12l4.263 4.264-1.245 1.246c-2.29 2.286-6.012 2.29-8.302 0L6.29 14.59A5.85 5.85 0 0 1 5.241 7.71 1.141 1.141 0 1 0 3.22 6.647a8.12 8.12 0 0 0 1.455 9.56l11.118 11.119a8.1 8.1 0 0 0 5.768 2.388 8.1 8.1 0 0 0 5.766-2.388l2.054-2.054a1.143 1.143 0 0 0 0-1.616zM29.625 2.986a1.1 1.1 0 0 0-.246-.366q-.002-.004-.004-.006c-.039-.038-.088-.054-.13-.085-.078-.058-.151-.12-.241-.156-.096-.04-.197-.048-.298-.06-.046-.006-.087-.027-.135-.027h-4.57a1.142 1.142 0 1 0 0 2.285h1.836l-4.844 4.911a1.147 1.147 0 0 0 .012 1.618 1.144 1.144 0 0 0 1.618-.01l4.806-4.873V8a1.142 1.142 0 1 0 2.285 0V3.425c0-.15-.03-.299-.089-.439Z"
    })
  }));
};
CallOutgoingIcon.displayName = 'CallOutgoingIcon';